var _ = require('lodash');

module.exports = {
  MATCH_DESCENDANT_KEY: /Definition$/,
  DEFAULT_CONFIGURATION: {
    defaultToRequired: false,
    integritySafeguards: true,
    failFast: false,
    logFailureFn: function () {
      var args = Array.prototype.slice.call(arguments);

      if (!!window.log) {
        window.log.error.apply(log, args);
      } else {
        console.error.apply(console, args);
      }
    }
  },
  discoverType: (function discoverType() {
    var class2type = {};

    _.each(
      ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Object', 'Error'],
      function (name, i) {
        this['[object ' + name + ']'] = name.toLowerCase();
      },
      class2type
    );

    return function typeFinder(obj) {
      if (obj == null) {
        return obj + '';
      }

      return typeof obj === 'object' || typeof obj === 'function'
        ? class2type[class2type.toString.call(obj)] || 'object'
        : typeof obj;
    };
  })()
};



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/constants.js